import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTablet = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-1.44 -1.44 46 46",
	height: "1em",
	width: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m6.726720000000001 33.6875 29.645000000000003 0",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2.88
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.42711 1.3475000000000001h24.255000000000003s2.6950000000000003 0 2.6950000000000003 2.6950000000000003v35.035000000000004s0 2.6950000000000003 -2.6950000000000003 2.6950000000000003h-24.255000000000003s-2.6950000000000003 0 -2.6950000000000003 -2.6950000000000003V4.0425s0 -2.6950000000000003 2.6950000000000003 -2.6950000000000003",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2.88
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.469610000000001 9.432500000000001h5.390000000000001v5.390000000000001h-5.390000000000001Z",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2.88
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.249610000000004 9.432500000000001h5.390000000000001v5.390000000000001h-5.390000000000001Z",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2.88
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.469610000000001 20.212500000000002h5.390000000000001v5.390000000000001h-5.390000000000001Z",
			fill: "none",
			stroke: "var(--icon-color, currentColor)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2.88
		})
	]
});
export default SvgTablet;
